import { render, staticRenderFns } from "./SearchBeneficiarySponsorForm.vue?vue&type=template&id=750f5040"
import script from "./SearchBeneficiarySponsorForm.vue?vue&type=script&lang=js"
export * from "./SearchBeneficiarySponsorForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports